import { Injectable } from '@angular/core';
import { Tone } from '../../../shared/enums/tone.enum';
import { WritingStyle } from '../../../shared/enums/writingStyle.enum';

@Injectable({
  providedIn: 'root'
})
export class RephraseOptionsService {
  public selectedTone: Tone = Tone.default;
  public selectedWritingStyle: WritingStyle = WritingStyle.default;
  public toneOptions = Object.values(Tone);
  public writingStyleOptions = Object.values(WritingStyle);
}
